import axiosInstance from "@/api/axiosInstance";
import {
  InitiatePaymentRefundRequest,
  InitiatePaymentRefundResponse,
} from "./types";

export const initiatePaymentRefund = async (
  requestData: InitiatePaymentRefundRequest,
): Promise<InitiatePaymentRefundResponse> => {
  // Updated to use invoices endpoint
  const url = `/api/private/invoices/${requestData.uuid}/refund`;

  const { ...payload } = requestData;

  const response = await axiosInstance.post<InitiatePaymentRefundResponse>(
    url,
    payload,
  );

  return response.data;
};
